// Restores a thread's saved scroll offset when its viewport mounts. A thread
// opened for the first time in this browser session has no saved offset and
// starts at the top, so the reader begins with the first exchange rather
// than landing mid-way through the latest response.
export function restoreThreadScrollTop(viewport: HTMLElement, saved: string | null) {
  viewport.scrollTop = Number(saved) || 0;
}

export function scrollToCurrentTurnStart(viewport: HTMLElement) {
  const viewportTop = viewport.getBoundingClientRect().top;
  const messages = Array.from(viewport.querySelectorAll<HTMLElement>('[data-role="user"], [data-role="assistant"]'));
  const currentMessage = messages.find((message) => {
    const { top, bottom } = message.getBoundingClientRect();
    return top <= viewportTop + 8 && bottom > viewportTop + 8;
  });
  const currentOrNextMessage = currentMessage
    ?? messages.find((message) => message.getBoundingClientRect().top > viewportTop + 8)
    ?? messages.at(-1);
  if (!currentOrNextMessage) return false;

  const currentIndex = messages.indexOf(currentOrNextMessage);
  const target = currentOrNextMessage.dataset.role === 'user'
    ? currentOrNextMessage
    : messages.slice(0, currentIndex).reverse().find((message) => message.dataset.role === 'user')
      ?? currentOrNextMessage;

  const targetTop = viewport.scrollTop + target.getBoundingClientRect().top - viewportTop - 8;
  viewport.scrollTo({ top: Math.max(0, targetTop), behavior: 'smooth' });
  return true;
}
